import React, { useState } from "react";
import { SlArrowLeft } from "react-icons/sl";
import { Link, useNavigate } from "react-router-dom";
import api from "../utils/api";

const Pass = () => {
   const user = JSON.parse(localStorage.getItem("user"));

  const [formData, setFormData] = useState({
    type: "guest",
    date: "",
    visit_time: "",
    phone_number: "",
    purpose: "",
    guest_name: "",
    delivery_place: "",
    delivery_service: "",
    vehicle_type: "",
    vehicle_number: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmiting, setIsSubmiting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevformData) => ({
      ...prevformData,
      [name]: value,
    }));
  };

  const navigate = useNavigate();
  
  
 
  const userId = user?.id;
  const invitedBy = user?.name||'';

  const handlesubmit = async (e) => {
    e.preventDefault();
    
    // Check if user is logged in
    if (!userId) {
      alert("Please log in to generate a pass");
      navigate("/login"); // Adjust to your login route
      return;
    }
    
    if (validateForm()) {
      setIsSubmiting(true);
      
      // Build request data based on type
      const requestData = {
        user_id: userId,
        type: formData.type,
        date: formData.date,
        visit_time: formData.visit_time,
        phone_number: formData.phone_number || undefined,
        purpose: formData.purpose || undefined,
        invited_by: invitedBy,
        status: 1,
      };

      // Add type-specific fields
      if (formData.type === "guest") {
        requestData.guest_name = formData.guest_name;
      } else if (formData.type === "delivery") {
        requestData.delivery_place = formData.delivery_place;
        requestData.delivery_service = formData.delivery_service;
      } else if (formData.type === "vehicle") {
        requestData.vehicle_type = formData.vehicle_type;
        requestData.vehicle_number = formData.vehicle_number;
      }

      try {
        const response = await api.post('/passes', requestData);
        const data = response.data;
        alert("Pass generation successful");
        localStorage.setItem("nwedata", JSON.stringify(formData));
        localStorage.setItem("otp", JSON.stringify(data));
        navigate("/pass");
      } catch (error) {
        console.error("Error:", error);
        alert(error?.response?.data?.message || "An error occurred");
      } finally {
        setIsSubmiting(false);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.type) {
      newErrors.type = "Type is required";
      isValid = false;
    }

    if (!formData.date) {
      newErrors.date = "Date is required";
      isValid = false;
    }

    if (!formData.visit_time) {
      newErrors.visit_time = "Time is required";
      isValid = false;
    }

    // Type-specific validation
    if (formData.type === "guest" && !formData.guest_name.trim()) {
      newErrors.guest_name = "Guest name is required";
      isValid = false;
    }

    if (formData.type === "delivery") {
      if (!formData.delivery_place.trim()) {
        newErrors.delivery_place = "Delivery place is required";
        isValid = false;
      }
      if (!formData.delivery_service.trim()) {
        newErrors.delivery_service = "Delivery service is required";
        isValid = false;
      }
    }

    if (formData.type === "vehicle") {
      if (!formData.vehicle_type.trim()) {
        newErrors.vehicle_type = "Vehicle type is required";
        isValid = false;
      }
      if (!formData.vehicle_number.trim()) {
        newErrors.vehicle_number = "Vehicle number is required";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  return (
    <div className="flex justify-center bg-slate-800 w-[100%] min-h-[100vh]">
      <div className="w-[390px] bg-white mb-20">
        <div className="flex px-6 py-4">
          <div className="items-center my-auto">
            <Link to="/userdash">
              <SlArrowLeft />
            </Link>
          </div>
          <h3 className="font-bold flex justify-center mx-auto text-[22px]">
            Generate pass
          </h3>
        </div>
        <div className="bg-slate-200 px-6 pb-20 pt-6">
          <form className="flex flex-col gap-5" onSubmit={handlesubmit}>
            {/* Pass Type Selection */}
            <div>
              <select
                className="rounded-xl w-full py-4 px-4 bg-white shadow-slate-400 shadow-sm"
                name="type"
                value={formData.type}
                onChange={handleInputChange}
              >
                <option value="guest">Guest</option>
                <option value="delivery">Delivery</option>
                <option value="vehicle">Vehicle</option>
              </select>
              {errors.type && (
                <span className="text-red-500 text-sm">{errors.type}</span>
              )}
            </div>

            {/* Guest Type Fields */}
            {formData.type === "guest" && (
              <div>
                <input
                  className="rounded-xl w-full py-4 px-4 shadow-slate-400 shadow-sm"
                  type="text"
                  name="guest_name"
                  placeholder="Guest Name"
                  value={formData.guest_name}
                  onChange={handleInputChange}
                />
                {errors.guest_name && (
                  <span className="text-red-500 text-sm">{errors.guest_name}</span>
                )}
              </div>
            )}

            {/* Delivery Type Fields */}
            {formData.type === "delivery" && (
              <>
                <div>
                  <select
                    className="rounded-xl w-full py-4 px-4 bg-white shadow-slate-400 shadow-sm"
                    name="delivery_service"
                    value={formData.delivery_service}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Delivery Service</option>
                    <option value="Foodmandu">Foodmandu</option>
                    <option value="Pathao Food">Pathao Food</option>
                    <option value="Bhoj Deals">Bhoj Deals</option>
                    <option value="Daraz">Daraz</option>
                  </select>
                  {errors.delivery_service && (
                    <span className="text-red-500 text-sm">{errors.delivery_service}</span>
                  )}
                </div>
                <div>
                  <input
                    className="rounded-xl w-full py-4 px-4 shadow-slate-400 shadow-sm"
                    type="text"
                    name="delivery_place"
                    placeholder="Delivery Place (e.g., Indoor/Outdoor, Gate A)"
                    value={formData.delivery_place}
                    onChange={handleInputChange}
                  />
                  {errors.delivery_place && (
                    <span className="text-red-500 text-sm">{errors.delivery_place}</span>
                  )}
                </div>
              </>
            )}

            {/* Vehicle Type Fields */}
            {formData.type === "vehicle" && (
              <>
                <div>
                  <select
                    className="rounded-xl w-full py-4 px-4 bg-white shadow-slate-400 shadow-sm"
                    name="vehicle_type"
                    value={formData.vehicle_type}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Vehicle Type</option>
                    <option value="Two Wheeler">Two Wheeler</option>
                    <option value="Four Wheeler">Four Wheeler</option>
                  </select>
                  {errors.vehicle_type && (
                    <span className="text-red-500 text-sm">{errors.vehicle_type}</span>
                  )}
                </div>
                <div>
                  <input
                    className="rounded-xl w-full py-4 px-4 shadow-slate-400 shadow-sm"
                    type="text"
                    placeholder="Vehicle Number"
                    name="vehicle_number"
                    value={formData.vehicle_number}
                    onChange={handleInputChange}
                  />
                  {errors.vehicle_number && (
                    <span className="text-red-500 text-sm">{errors.vehicle_number}</span>
                  )}
                </div>
              </>
            )}

            {/* Common Fields */}
            <div>
              <input
                className="rounded-xl w-full py-4 px-4 bg-white shadow-slate-400 shadow-sm"
                type="date"
                placeholder="Date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
              />
              {errors.date && (
                <span className="text-red-500 text-sm">{errors.date}</span>
              )}
            </div>

            <div>
              <input
                className="rounded-xl w-full py-4 px-4 bg-white shadow-slate-400 shadow-sm"
                type="time"
                placeholder="Visit Time"
                name="visit_time"
                value={formData.visit_time}
                onChange={handleInputChange}
              />
              {errors.visit_time && (
                <span className="text-red-500 text-sm">{errors.visit_time}</span>
              )}
            </div>

            <div>
              <input
                className="rounded-xl w-full py-4 px-4 shadow-slate-400 shadow-sm"
                type="tel"
                placeholder="Phone Number (Optional)"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleInputChange}
              />
            </div>

            <div>
              <input
                className="rounded-xl w-full py-4 px-4 shadow-slate-400 shadow-sm"
                type="text"
                placeholder="Purpose (Optional)"
                name="purpose"
                value={formData.purpose}
                onChange={handleInputChange}
              />
            </div>

            <button
              type="submit"
              className="bg-[#403F93] text-white mx-auto flex px-24 py-3 rounded-3xl mt-6 disabled:opacity-50"
              disabled={isSubmiting}
            >
              {isSubmiting ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Pass;